import Player from '@vimeo/player';
import YTPlayer from 'yt-player';

const vimeoWrap = document.querySelector('.vimeo-wrapper');
const youtubeWrap = document.querySelector('.youtube-wrapper');

const container = document.querySelector('.wp-block-leanpathblocks-hero__image-wrap');
const containernMobile = document.querySelector('.wp-block-leanpathblocks-hero__mobile-image');

const btn = document.querySelector('.play-video');
const btnMobile = document.querySelector('.play-mobile-video');

if ( vimeoWrap ) {
    const options = {
        id: vimeoWrap.dataset.id,
        width: 640,
        loop: false,
    };
    const vimeoVideo = new Player('vimeo-video', options);
    const vimeoVideoMobile = new Player('vimeo-mobile-video', options);
    
    btn.addEventListener('click', () => {
        vimeoVideo.play();
        container.classList.add('is-playing');
    });

    btnMobile.addEventListener('click', () => {
        vimeoVideoMobile.play();
        containernMobile.classList.add('is-playing');
    });
}

if ( !vimeoWrap && youtubeWrap ) {
    const youtubeVideo = new YTPlayer('#youtube-video');
    const youtubeVideoMobile = new YTPlayer('#youtube-mobile-video');

    youtubeVideo.load(youtubeWrap.dataset.id);
    youtubeVideoMobile.load(youtubeWrap.dataset.id);

    btn.addEventListener('click', () => {
        youtubeVideo.play();
    });

    btnMobile.addEventListener('click', () => {
        youtubeVideoMobile.play();
    });

    youtubeVideo.on('playing', () => {
        container.classList.add('is-playing');
    });

    youtubeVideoMobile.on('playing', () => {
        containernMobile.classList.add('is-playing');
    });
}